export default __webpack_public_path__ + "static/media/treelogoW.b214c2ee.png";